<!--
 * @Author: your name
 * @Date: 2020-08-26 15:52:15
 * @LastEditTime: 2024-07-31 17:42:53
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \Kares\src\components\system\MediaManage.vue
-->
<template>
  <div class="media-manage">
    <enfold>
      <enfold-uc>
        <template slot="up">
          <div class="c-u-left">{{$t('csm1')}}</div>
          <div class="c-u-right">{{$t('csm2')}}</div>
        </template>
        <template slot="center">
          <el-tree
            :data="configList"
            :props="{children: 'child', label: 'remark'}"
            default-expand-all
            :expand-on-click-node="false"
            v-loading="loading"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <img class="icon" src="@/assets/images/public/public_add.png" @click="() => append(data)" alt />
                <img class="icon" src="@/assets/images/public/public_delete.png" @click="() => remove(data)" alt />
              </span>
            </span>
          </el-tree>
        </template>
      </enfold-uc>
    </enfold>
    <form-dialog
      :dialogVisible="FormDialogVisible"
      @closeDialog="FormCloseDialog"
      :title="$t('csm3')"
      dWidth="400px"
    >
      <div class="form-dialog">
        <el-form :model="listForm" :rules="rules" ref="listForm" label-width="100px">
          <el-form-item :label="$t('csm4')" prop="name">
            <el-input v-model="listForm.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('csm5')" prop="remark">
            <el-input v-model="listForm.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('listForm')" round>{{$t('csm6')}}</el-button>
            <el-button type="primary" @click="submitForm('listForm')" round>{{$t('csm7')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-dialog>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('csum19')">
      <div class="dd-dialog">{{$t('csm8')}}</div>
    </del-dialog>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold'
import EnfoldUc from '@/components/basics/EnfoldUC'
import DelDialog from '@/components/basics/DelDialog'
import FormDialog from '@/components/basics/FormDialog'
export default {
  name: "MediaManage",
  data() {
    return {
      FormDialogVisible: false,
      DelDialogVisible: false,
      loading: true,
      configList: [],
      configItem: {},
      listForm: {
        name: "",
        remark: ""
      },
      rules: {
        name: [
          { required: true, message: this.$t('csm9'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('csm10'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getConfigList();
  },
  methods: {
    getConfigList() {
      this.loading = true;
      this.$http.post("/admin/material/configList", { flag: 1 }, data => {
        this.configList = data.dir;
        this.loading = false;
      });
    },
    FormCloseDialog() {
      this.FormDialogVisible = false;
    },
    async DelCloseDialog(isConfirm = false) {
      if (isConfirm) {
        await this.$http.post("/admin/material/delDir", { id: this.configItem.id }, data => {
          console.log(data);
          this.getConfigList();
        });
      }
      this.DelDialogVisible = false;
    },
    resetForm(listForm) {
      this.$refs[listForm].resetFields();
      this.FormDialogVisible = false;
    },
    submitForm(listForm) {
      this.$refs[listForm].validate((valid) => {
        if (valid) {
          let addDir = {
            name: this.listForm.name,
            remark: this.listForm.remark,
            pid: this.configItem.id,
            type: this.configItem.type
          };
          this.$http.post("/admin/material/addDir", addDir, data => {
            console.log(data);
            this.getConfigList();
            this.FormDialogVisible = false;
          });
          this.$refs[listForm].resetFields();
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    append(data) {
      console.log(data);
      this.configItem = data;
      this.FormDialogVisible = true;
    },
    remove(data) {
      console.log(data);
      this.configItem = data;
      this.DelDialogVisible = true;
    }
  },
  components: {
    enfold,
    DelDialog,
    FormDialog,
    EnfoldUc
  }
}
</script>

<style lang="scss" scoped>
.media-manage {
  width: 100%;
  height: 100%;
  .c-u-right {
    padding-right: 30px;
  }
  .el-tree {
    padding: 0px 20px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    padding-right: 8px;
    .icon {
      width: 30px;
      margin-left: 30px;
    }
  }
  /deep/ .el-tree-node__content {
    height: 40px;
    border-bottom: 1px dashed #d9d9d9;
    .el-button {
      margin-left: -26px;
    }
  }
}
</style>